































import Vue from 'vue'

export default Vue.component('ScrollButtons', {
  props: {
    left: {
      type: Boolean,
      default: false,
      required: false
    },
    right: {
      type: Boolean,
      default: true,
      required: false
    },
    stepSize: {
      type: Number,
      default: 200,
      required: false
    },
    color: {
      type: String,
      default: 'white'
    },
    dark: {
      type: Boolean,
      default: false
    },
    elevation: {
      type: Number,
      default: 1,
      required: false
    },
    content: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      required: false,
      default: 0
    }
  },

  methods: {
    scroll(this:any, e:Event, direction:string) {
      e.preventDefault();
      const content = document.getElementsByClassName(this.content)[this.index] || document.getElementById(this.content)
      if (content) {
        if (direction === 'right') {
          content.scrollLeft += this.stepSize;
        } else {
          content.scrollLeft -= this.stepSize;
        }
      }
    }
  }
})
